import headerCarouselImg from '@/assets/images/home/home-header-image-original.png';
import headerCarouselImg2 from '@/assets/images/home/home-header-image-2.png';
export default {
  homeView: {
    title: '<span style="color: #A31C25;">Découvrez</span> et <span style="color: #A31C25;">trouvez</span> les produits selon vos préférences',
    headerCarousel: {
      printListIp: 'Imprimer la liste IP',
      printListSaq: 'Imprimer la liste SAQ',
      exploreAgencyProduct: "Explorer les produits de l'agence",
    },
    productCarousel: {
      allProducts: 'Tous les produits',
    },
    blogVideosCarousel: {
      title: 'vidéos',
      allVideosLink: 'Tous les vidéos',
    },
    blogVideo1Carousel: {
      title: 'boires en importation privé',
      description: 'C\'est quoi i\'ip',
    },
    blogVideo2Carousel: {
      title: 'boires sur les tablettes',
      description: 'Renaissance, Champagne 1er cru Cumiéres de Vadin-Plateau',
    },
    blogVideo3Carousel: {
      title: 'boires sur les tablettes',
      description: 'PB de Alta Allella',
    },
    blogsCarousel: {
      title: 'blogue',
      title1: 'Blogues',
      allBlogsLink: 'Tous les blogues',
    },
    becomeMember: {
      title: 'Devenir membre',
      content: 'Un membre a accès à des allocations de vin privilégiées, des conseils sur mesure, des prix préférentiels, des dégustations sur rendez-vous et bien plus.',
    },
    discoveryPackages: {
      title: 'Forfaits découverte',
      content: "Livraison mensuelle d'une caisse découverte contenant 6 bouteilles différentes. "
        + 'Plusieurs forfaits sont disponibles et vous pourrez choisir le forfait qui vous correspond. Vive la découverte, vive les vins bio!',
    },
    infoRegisterForm: {
      title: 'info',
      subTitle: 'Restez informé de nos offres et dernières nouveautés',
      firstName: 'Prénom',
      lastName: 'Nom',
      email: 'Courriel',
      cta: "S'abonner",
    },
    cta: {
      readMore: 'En savoir plus',
    },
    blogCarouselStatic: {
      title: 'LE VIGNERON PUNK DU JURA',
      subTitle: 'Didier Grappe',
      content: 'Didier Grappe produit des vins de terroirs avec des vinifications sans intrants afin de produire des vins qui expriment la quintessence du lieu.'
    },
    ProductCarouselSection: {
      ValentineDay: 'Sans alcool',
      NewArrivals: 'Nouveautés',
      InStore: 'En boutique',
    }
  },
  category: {
    valentinesDay: 'Saint-Valentin',
    news: 'Nouveautés',
    inStore: 'En boutique'
  },
  headerCarousel: [
    {
      title: 'LEVONS NOS <span style="color: #A31C25;">VERRES</span> À CEUX QUI PIOCHENT DANS LES <span style="color: #A31C25;">VIGNES</span>',
      image: headerCarouselImg,
      btn1: 'Imprimer la liste IP',
      btnLink1: '',
      btn2: 'Imprimer la liste SAQ',
      btnLink2: '',
      btn3: "Explorer les produits de l'agence",
      btnLink3: "/products",
    },
    {
      title: 'NOS <span style="color: #A31C25;">BOUTIQUE</span> POUR MANGER EN GROUPE Ou POUR FAIRE L\'APéRO ',
      image: headerCarouselImg2,
      btn1: 'Montréal',
      btnLink1: 'products?inventory=STORE_MTL',
      btn2: 'Québec',
      btnLink2: 'products?inventory=STORE_QC&page=1&size=52',
      btn3: "Toronto",
      btnLink3: "products?inventory=STORE_TORONTO",
    }
  ],
  cookiesModal: {
    title: 'Bienvenue à Boires ',
    p1: 'Ce site web d’adresse aux personnes',
    p2: 'd’âge legale pour consommer de l’alcool',
    p3: 'En achetant sur ce site,',
    p4: 'tu reconnais avoir plus de 18 ans',
    submit: 'Accepter et continuer',
    remember: 'Souviens-toi de moi',
    denyMessage: "À bientôt! Revenez lorsque vous aurez l'âge légal pour consommer de l'alcool"
  },
  cookiesModalOn: {
    title: 'Bienvenue à Boires ',
    p1: 'Ce site web d’adresse aux personnes',
    p2: 'd’âge legale pour consommer de l’alcool',
    p3: 'En achetant sur ce site,',
    p4: 'tu reconnais avoir plus de 19 ans',
    submit: 'Accepte & continue',
    remember: 'Souviens-toi de moi'
  },
  newsletter: {
    title: 'BOIRES ONTARIO NEWSLETTER',
    title1: 'Restez au courant de toutes les mises à jour et de tous les événements concernant le vin ',
    titleQC: 'Reste à l\'affut de nos prochains arrivages!',
    provincePlaceholder: 'Province',
    iLike: 'J\'aimerais en savoir plus sur',
    subscribe: 'S\'abonner',
    cancel: 'Annuler',
    Qcop1: 'Arrivées à SAQ',
    Qcop2: 'Arrivées IP',
    Qcop3: 'Nos événements',
    Qcop4: 'Notre boutique',
    OnOp1: 'Ordres privés',
    OnOp2: 'Evénements',
    OnOp3: 'Notre boutique',
    OnOp4: 'LCBO',
    success: 'Merci de vous être abonné !',
    info: 'Vous êtes déjà inscrit !',
    errormsg: 'Une erreur s\'est produite. Veuillez réessayer.',
  },
  provinceModalQc: 'Tu navigue sur l’interface du site web de Boires, pour la province du Québec',
  provinceModalOn: 'Tu navigue sur l’interface du site web de Boires, pour la province de l’Ontario'
};
